<template>
    <div>
        <div class="white-box mt-3">
            <div class="data-group">
                <M3FormTitle title="Planul de afaceri" :checked="completed"></M3FormTitle>
                <b-form>
                    <div class="activitate">
                        <div class="header">
                            <span class="title">
                                <strong>Secțiunea 2: Propunerea de proiect</strong>
                            </span>
                        </div>
                        <div class="flex green-item space-between">
                            <div class="value-title">
                                <span>Denumire întreprindere</span>
                            </div>
                            <div class="value-show">
                                <span>{{ allData ? allData.name : '' }}</span>
                            </div>
                        </div>
                        <div class="flex green-item space-between">
                            <div class="value-title">
                                <span>Adresa completă a sediului social</span>
                            </div>
                            <div class="value-show">
                                <span>{{ allData ? allData.address : '' }}</span>
                            </div>
                        </div>
                        <div class="flex green-item space-between">
                            <div class="value-title">
                                <span>Cod unic de înregistrare</span>
                            </div>
                            <div class="value-show">
                                <span>{{ allData ? allData.business_id : '' }}</span>
                            </div>
                        </div>
                        <div class="flex green-item space-between">
                            <div class="value-title">
                                <span>Nr înmatriculare la ONRC</span>
                            </div>
                            <div class="value-show">
                                <span>{{ allData ? allData.reg_no : '' }}</span>
                            </div>
                        </div>
                    </div>
                    <p class="info-text">Vă rugăm să completați secțiunile de mai jos</p>
                    <Scop :scop="scop" :all-data="allData" @unsavedChanges="$emit('unsavedChanges', $event)" @formIncomplete="$emit('formIncomplete', 'scop')" @formComplete="$emit('formComplete', 'scop')"></Scop>
                    <Situatie :situatieInitiala="situatieInitiala" :all-data="allData" @unsavedChanges="$emit('unsavedChanges', $event)" @formIncomplete="$emit('formIncomplete', 'situatie')" @formComplete="$emit('formComplete', 'situatie')"></Situatie>
                    <Obiective :obiective="obiective" :all-data="allData" @unsavedChanges="$emit('unsavedChanges', $event)" @formIncomplete="$emit('formIncomplete', 'obiective')" @formComplete="$emit('formComplete', 'obiective')"></Obiective>
                    <MediuExtern :mediuExtern="mediuExtern" :allData="allData" @unsavedChanges="$emit('unsavedChanges', $event)" @formIncomplete="$emit('formIncomplete', 'mediuExtern')" @formComplete="$emit('formComplete', 'mediuExtern')"></MediuExtern>
                    <AnalizaSWOT :swot="swot" @unsavedChanges="$emit('unsavedChanges', $event)" @formIncomplete="$emit('formIncomplete', 'analizaSWOT')" @formComplete="$emit('formComplete', 'analizaSWOT')"></AnalizaSWOT>
                    <EtapeTinte :etapeTinte="etapeTinte" :allData="allData" @unsavedChanges="$emit('unsavedChanges', $event)" @formIncomplete="$emit('formIncomplete', 'etape')" @formComplete="$emit('formComplete', 'etape')"></EtapeTinte>
                    <ActivitatiGantt :activitati="gantt" class="gantt-custom"></ActivitatiGantt>
                    <b-form class="mt-4">
                        <b-overlay :show="budgetDownload">
                            <PlanInputContent
                                title="H. Bugetul proiectului"
                                warn="Ți-am generat automat bugetul în conformitate cu modelul solicitat în planul de afaceri din Ghidul Solicitantului. Te rugăm să îl descarci și să te asiguri că informațiile sunt corecte."
                            >
                                <template v-slot:body>
                                    <div class="sub-item">
                                        <div class="document" @click="downloadBudget('pdf')">
                                            <img src="@/assets/images/M3/M3Sketch/pdf_icon.png" class="download_icon" alt="pdf_icon" >
                                            <span>Descarcă bugetul tău generat în format .pdf</span>
                                        </div>
                                        <div class="document" @click="downloadBudget('xls')">
                                            <img src="@/assets/images/M3/M3Sketch/exel_icon.png" class="download_icon" alt="exel_icon" >
                                            <span>Descarcă bugetul tău generat în format .xls</span>
                                        </div>
                                    </div>
                                </template>
                            </PlanInputContent>
                        </b-overlay>
                    </b-form>
                    <ContributiaProiectuluiMediu :obiective="obiectiveMediu" :allData="allData" :statistics="statistics"></ContributiaProiectuluiMediu>
                    <IdentificareaRiscurilor :riscuri="riscuri" @formIncomplete="$emit('formIncomplete', 'riscuri')" @formComplete="$emit('formComplete', 'riscuri')"></IdentificareaRiscurilor>
                    <b-form class="mt-4">
                        <PlanInputContent
                            title="K. PROIECŢII FINANCIARE"
                        >
                            <template v-slot:body>
                                <div class="yellow-warning">
                                    <img src="@/assets/images/exclamation-mark-icon.png" alt="exclamation-mark-icon">
                                    <div>
                                        Documentul pentru proiecții financiare este disponibil în secțiunea <router-link to="/aplicatii/m3-sketch/indicatori">INDICATORI</router-link>. Îl vom genera și îl adăugăm la planul tău de afaceri. Dacă dorești să editezi acest document te rugăm să accesezi secțiunea <router-link to="/aplicatii/m3-sketch/indicatori">INDICATORI</router-link>. <br><br>
                                    </div>
                                </div>
                            </template>
<!--                            <template v-slot:body>-->
<!--                                <div class="sub-item">-->
<!--                                    <div class="document" @click="underConstructionProjections('download')">-->
<!--                                        <img src="@/assets/images/M3/M3Sketch/exel_icon.png" class="download_icon" alt="exel_icon" >-->
<!--                                        <span>Descarcă model proiecții financiare</span>-->
<!--                                    </div>-->
<!--&lt;!&ndash;                                    <div class="document" @click="underConstructionProjections('upload')">&ndash;&gt;-->
<!--&lt;!&ndash;                                        <img src="@/assets/images/M3/M3Sketch/exel_icon.png" class="download_icon" alt="exel_icon" >&ndash;&gt;-->
<!--&lt;!&ndash;                                        <span>Încarcă document de proiecții financiare</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                    </div>&ndash;&gt;-->
<!--                                </div>-->
<!--                                <p class="mt-3 mb-0">Mai avem putin de lucru la aceasta functie, pentru a o adapta cu usurinta la ghidul final. Te tinem la curent.</p>-->
<!--                            </template>-->
                        </PlanInputContent>
                    </b-form>

                    <b-overlay :show="documentDownload">
                        <a class="download-button" :class="!paid ? 'button-red' : ''" @click="downloadFile($event)">
                            <div class="text-left">
                                <span>Descarcă planul tău de afaceri final</span>
                                <b-icon-check-circle-fill v-if="paid" font-scale="1.2"></b-icon-check-circle-fill>
                                <b-icon-x-circle-fill v-else font-scale="1.2"></b-icon-x-circle-fill>
                            </div>
                            <div class="image-right">
                                <img src="@/assets/images/M3/M3Sketch/zip-icon.png" class="download_icon" alt="zip_icon" >
                            </div>
                        </a>
                    </b-overlay>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import M3FormTitle from '../M3FormTitle'
    import { BForm, BFormInput, BFormCheckbox, BFormTextarea, BIconPencilSquare, BIconCheckCircleFill, BTable, BIconXCircleFill, BOverlay} from "bootstrap-vue";
    import PlanInputContent from '@/pages/Aplicatii/M3/M3Sketch/components/plan-afaceri/PlanInputContent'
    import Scop from '@/pages/Aplicatii/M3/M3Sketch/components/plan-afaceri/Scop'
    import Situatie from '@/pages/Aplicatii/M3/M3Sketch/components/plan-afaceri/Situatie'
    import Obiective from '@/pages/Aplicatii/M3/M3Sketch/components/plan-afaceri/Obiective'
    import MediuExtern from '@/pages/Aplicatii/M3/M3Sketch/components/plan-afaceri/MediuExtern'
    import AnalizaSWOT from '@/pages/Aplicatii/M3/M3Sketch/components/plan-afaceri/AnalizaSWOT'
    import EtapeTinte from '@/pages/Aplicatii/M3/M3Sketch/components/plan-afaceri/EtapeTinte'
    import ContributiaProiectuluiMediu from '@/pages/Aplicatii/M3/M3Sketch/components/plan-afaceri/ContributiaProiectuluiMediu'
    import ActivitatiGantt from '@/pages/Aplicatii/M3/M3Sketch/components/activitati-forms/ActivitatiGantt'
    import colorsJSON from '@/pages/Aplicatii/M3/M3Sketch/components/activitati-forms/colors.json'
    import IdentificareaRiscurilor from '@/pages/Aplicatii/M3/M3Sketch/components/plan-afaceri/IdentificareaRiscurilor'
    import Vue from 'vue';
    import VueSweetalert2 from 'vue-sweetalert2';
    import 'sweetalert2/dist/sweetalert2.min.css';
    import api from '@/helpers/api'
    import axios from '@/helpers/axios'
    Vue.use(VueSweetalert2);
    export default {
        components: {
            BForm,
            BFormInput,
            PlanInputContent,
            Scop,
            Situatie,
            Obiective,
            MediuExtern,
            AnalizaSWOT,
            EtapeTinte,
            ContributiaProiectuluiMediu,
            ActivitatiGantt,
            IdentificareaRiscurilor,
            BFormCheckbox,
            BFormTextarea,
            BIconPencilSquare,
            BIconCheckCircleFill,
            M3FormTitle,
            VueSweetalert2,
            BTable,
            BIconXCircleFill,
            BOverlay
        },
        props: {
            completed: null,
        },
        data() {
            return {
                title: 'Test 1',
                scop: null,
                situatieInitiala: null,
                obiective: null,
                mediuExtern: null,
                swot: null,
                etapeTinte: null,
                riscuri: null,
                documentDownload: false,
                paid: true,
                budgetDownload: false,
                gantt: [],
                obiectiveMediu: null,
                colors: colorsJSON,
                linkDownload: api.API_ROOT + '/m3-manager/companies/' + JSON.parse(localStorage.getItem('currentM3Company')).id + '/documents/business-plan'
            }
        },
        computed: {
            statistics() {
                return this.$store.getters['m3Sketch/indicators']
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        watch: {
            allData: {
                handler: function() {
                    if(this.allData !== null && this.allData.m3_project){
                        this.scop = this.allData.m3_project.business_plan_scope ? this.allData.m3_project.business_plan_scope : ''
                        this.situatieInitiala = this.allData.m3_project.business_plan_initial_state ? this.allData.m3_project.business_plan_initial_state : ''
                        this.obiective = this.allData.m3_project.business_plan_objectives ? this.allData.m3_project.business_plan_objectives : ''
                        this.mediuExtern = this.allData.m3_project.business_plan_external_environment ? this.allData.m3_project.business_plan_external_environment : ''
                        this.swot = this.allData.m3_project.business_plan_swot ? this.allData.m3_project.business_plan_swot : ''
                        this.etapeTinte = this.allData.m3_project.business_plan_stages_targets ? this.allData.m3_project.business_plan_stages_targets : ''
                        this.obiectiveMediu = this.allData.m3_project.business_plan_green_environment ? this.allData.m3_project.business_plan_green_environment : ''
                        this.riscuri = this.allData.m3_project.business_plan_risks ? this.allData.m3_project.business_plan_risks : ''
                        this.paid = this.allData.paid
                    }
                    if(this.allData && this.allData.m3_project && this.allData.m3_project.activities && this.allData.m3_project.activities.activities) {
                        this.buildGantt()
                    }
                },
                deep: true,
                immediate: true
            },
        },
        mounted() {
            this.$store.dispatch('pageLoading/setLoading', false)
        },
        methods: {
            buildGantt() {
                if(this.gantt.length) {
                    this.gantt = []
                }
                let colorIndex = 0;
                this.allData.m3_project.activities.activities.forEach(activity => {

                    let color = this.colors[colorIndex % 7].color;
                    colorIndex++;

                    let min = 25;
                    let max = 0;

                    activity.childrens.forEach(child => {
                        if(min > child.date[0])
                            min = child.date[0]

                        if(max < child.date[1])
                            max = child.date[1]
                    })

                    this.gantt.push({
                        activity: activity,
                        fillColor: color,
                        date: [
                            min,
                            max
                        ]
                    });
                })
                this.$emit('gantBuilt', this.gantt)
                this.$store.dispatch('pageLoading/setLoading', false)
            },
            underConstruction(tip) {
                if(tip === 'pdf'){
                    this.$swal({
                        heightAuto: false,
                        title: 'Încă lucrăm la această funcționalitate.<br>' +
                            '<p style="font-size: 14px; text-align: center;">Documentele finale vor fi disponibile în formatul solicitat prin ghidul final, exclusiv pentru utilizatorii licențiați.</p>' +
                            '<a href="/documents/buget_demo.pdf" download class="swal2-confirm swal2-styled" style="display: inline-block; margin-top: 20px; margin-bottom: -20px;">Descarcă document demo</a>',
                        icon: 'info',
                        confirmButtonText: 'Închide'

                    })
                } else{
                    this.$swal({
                        heightAuto: false,
                        title: 'Încă lucrăm la această funcționalitate.<br>' +
                            '<p style="font-size: 14px; text-align: center;">Documentele finale vor fi disponibile în formatul solicitat prin ghidul final, exclusiv pentru utilizatorii licențiați.</p>' +
                            '<a href="/documents/buget_demo.xlsx" download class="swal2-confirm swal2-styled" style="display: inline-block; margin-top: 20px; margin-bottom: -20px;">Descarcă document demo</a>',
                        icon: 'info',
                        confirmButtonText: 'Închide'
                    })
                }
            },
            downloadBudget(type){
                this.budgetDownload = true
                let link = ''
                let name = JSON.parse(localStorage.getItem('currentM3Company')).name
                if(type === 'pdf'){
                    link = api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id +'/documents/budget_doc/xlsxToPdf'
                    name = 'buget_'+ name.replaceAll( /[^a-z0-9]+/ig, "_") +'.pdf'
                } else{
                    link = api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id +'/documents/budget_doc/xlsx'
                    name = 'buget_'+ name.replaceAll( /[^a-z0-9]+/ig, "_") +'.xlsx'
                }
                axios({url: link, method: 'GET', responseType: 'blob'})
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', name);
                        document.body.appendChild(link);
                        link.click();
                        this.budgetDownload = false
                    })
                    .catch(() => {
                        this.$swal({
                            title: 'Document disponibil companiilor cu licență activă.<br>Poți cumpăra o licență din pagina de mai jos.',
                            icon: 'info',
                            confirmButtonText: 'Cumpără licență',
                            showDenyButton: true,
                            denyButtonText: 'Anulează'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.$router.push({name: 'M3SketchCumparaLicenta'});
                            }
                        })
                        this.budgetDownload = false
                    })
            },
            underConstructionProjections(tip) {
                if(tip === 'download'){
                    this.$swal({
                        heightAuto: false,
                        title: 'Încă lucrăm la această funcționalitate.<br>' +
                            '<p style="font-size: 14px; text-align: center;">Documentul de previziuni financiare va fi disponibil precompletat, exclusiv pentru utilizatorii licențiați.</p>',
                        icon: 'info',
                    })
                } else{
                    this.$swal({
                        heightAuto: false,
                        title: 'Încă lucrăm la această funcționalitate.<br>' +
                            '<p style="font-size: 14px; text-align: center;">Această funcție va fi disponibilă  exclusiv pentru utilizatorii licențiați.</p>',
                        icon: 'info',
                    })
                }
            },
            downloadFile(event){
                event.preventDefault();
                if(this.paid){
                    this.documentDownload = true
                    this.$toast.success('Documentele se vor descărca in cateva secunde.');
                    location.href = this.linkDownload
                    this.documentDownload = false
                    // axios({url: this.linkDownload, method: 'GET', responseType: 'blob'})
                    //     .then(response => {
                    //         const url = window.URL.createObjectURL(new Blob([response.data]));
                    //         const link = document.createElement('a');
                    //         link.href = url;
                    //         link.setAttribute('download', 'ANEXA 4.2.doc');
                    //         document.body.appendChild(link);
                    //         link.click();
                    //         this.documentDownload = false
                    //     })
                    //     .catch(() => {
                    //         this.documentDownload = false
                    //     })
                } else {
                    this.$swal({
                        title: 'Document disponibil companiilor cu licență activă.<br>Poți cumpăra o licență din pagina de mai jos.',
                        icon: 'info',
                        confirmButtonText: 'Cumpără licență',
                        showDenyButton: true,
                        denyButtonText: 'Anulează',
                        heightAuto: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.$router.push({name: 'M3SketchCumparaLicenta'});
                        }
                    })
                }
            },
        }
    }
</script>

<style scoped>
.yellow-warning{
    margin-top: 10px;
    background: #ffffff;
    padding: 15px 30px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    border:1px solid #fcefcc;
}
.yellow-warning img{
    margin-right: 20px;
}
.yellow-warning >>> *{
    font-size: 12px;
    color: #525d6e;
    margin: 0;
}
.yellow-warning >>> ul{
    list-style: inside;
}
.yellow-warning a{
    color: #8c6984;
}
.white-box{
    background: #fff;
    padding: 20px;
    position: relative;
}
a:hover{
    text-decoration: none;
}
.data-group{
    margin: auto;
    width: 90%;
}
.flex{
    display: flex;
}
.space-between{
    justify-content: space-between;
}
.activitate{
    margin-top: 30px;
}
.activitate .header{
    background: #e9eaec;
    padding: 15px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.activitate .header span{
    color: #515679;
}
.switch-box{
    text-align: right;
    margin-top: 25px;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
.sub-item{
    margin-top: 10px;
}
.value-title, .value-show{
    background: #cdfaee;
    padding: 8px 20px;
    font-size: 14px;
    color: #515679;
}
.value-title{
    max-width: 300px;
    width: 100%;
    font-weight: 600;
    text-align: center;
}
.value-show{
    width: 100%;
    font-weight: 400;
}
.info-text{
    font-weight: 600;
    font-size: 16px;
    margin: 50px 0;
    color: #323653;
    display: flex;
    justify-content: flex-end;
}
.textarea{
    position: relative;
}
span >>>  textarea{
    border: 2px solid #9da2b0;
    background: #f8f9f9;
    color: #515679;
    font-size: 13px;
}
span >>>  textarea:focus{
    box-shadow: 0 0 0 0.2rem #cdfaee;
}
.textarea svg{
    position: absolute;
    top: 10px;
    right: 10px;
    color: #9da2b0;
}
span >>> textarea:read-only{
    background: #e5fffb;
}
.download-button{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 25px;
    background: #01e8c6;
    min-height: 55px;
    margin-top: 30px;
    transition: 0.4s;
    cursor: pointer;
}
.button-red{
    background: #ea8196 !important;
}
.button-red:hover{
    background: #c16577 !important;
}
.download-button:hover{
    background: #09c0a6;
}
.download-button .text-left{
    color: #fff;
    font-size: 16px;
    font-weight: 700;
}
.download-button .text-left span{
    margin-right: 10px;
}
.green-item{
    margin: 18px 0;
    gap: 0 15px;
}
.sub-item{
    display: flex;
    background: #f8f9f9;
    justify-content: space-between;
    padding: 15px 40px;
}
.document{
    font-size: 14px;
    color: #515679;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.document img{
    margin-right: 20px;
}
.gantt-custom{
    margin: 20px -35px 20px -35px !important;
}
@media (max-width: 1700px){
    .white-box{
        padding: 20px 35px !important;
    }
}
</style>
